import {fragments} from "@Common/react/fragments";
import {cnv}       from "@Common/utils/arr-path";

import {groupEnrollmentEditors} from "../../../../common/group-enrollment-editors";

export const enrollmentEditor = (m1, total) => (
    !m1.module?.enrollmentEditor ? total : (
        cnv(total, ["enrollmentEditor"], (_) => (
            !_ ? m1.module.enrollmentEditor : groupEnrollmentEditors([_, m1.module.enrollmentEditor])
        ))
    )
);
export const summaryLines = (m1, total) => !m1.module ? total : cnv(total, ["summaryLines"], () => m1.module);

// export const cleanItem = (m1, total) => !m1.module?.cleanItem ? (
//     total
// ) : changeNestedValue(total, ["cleanItem"], (_) => (
//     !_ ? (
//         m1.module.cleanItem
//     ) : (
//         (item) => chain(
//             item,
//             _,
//             m1.module.cleanItem,
//         )
//     )
// ));

export const ui = (priority, {hasSpacer=undefined}={}) => (m1, total, i) => !m1.module?.ui ? total : cnv(total, ["ui"], (_) => ([
    ..._??[],
    {
        priority,
        index: i,
        hasSpacer,
        ui: m1.module.ui,
    }
]));

export const renderAfter = (m1, total) => cnv(total, ["renderAfter"], (_) => (
    () => fragments(
        _?.(),
        m1.module?.renderAfter?.(),
    )
));



